import React from 'react';
import { CartProductListing, CartProductListingTheme } from '../cart-pdct-listing';
import { IDoorInstallationModel } from '../../../../entities-generated/models/project/door-installation-model';

interface ICartHandleListingProps {
  installation: IDoorInstallationModel;
  onSelected: () => void;
}

export const CartHandleListing: React.FunctionComponent<ICartHandleListingProps> = (props) => {
  const { installation } = props;
  const title = !!installation.selectedHandle ? installation.selectedHandle.description : 'Awaiting Selection';

  return (
    <CartProductListing
      theme={!!installation.selectedHandle ? CartProductListingTheme.Secondary : CartProductListingTheme.Grayscale}
      label={'Handle Choice'}
      variant={installation.selectedHandle?.textureVariant}
      showNotification={false}
      pricing={!!installation.selectedHandle? 'Included' : undefined}
      title={title}
      imageUrl={installation.selectedHandle?.textureVariant.productImageUrl}
      onSelected={props.onSelected}
    />
  );
};